<template>
  <div id="device-warn">
    <dv-border-box-13 class="device-warn-all">
      <audio id="myAudio" loop>
        <source src="./voice/voice7.wav" type="audio/mpeg">
      </audio>
      <div class="device-warn-top">
        <el-tooltip :content="$t('camera')" placement="top">
          <img @click="videoClick" class="device-warn-video" src="./img/videoNew.png"/>
        </el-tooltip>
        <dv-decoration-7 class="device-warn-title">&nbsp; {{$t('warnMsg')}} &nbsp;</dv-decoration-7>
        <el-tooltip :content="$t('THSet')" placement="top">
          <img @click="popClick" class="device-warn-set" src= './img/set.png'/>
        </el-tooltip>
      </div>
      <div ref="scrollWrapper" class="custom-scroll-wrapper" @mouseenter="pauseScroll" @mouseleave="resumeScroll">
        <table class="custom-table">
          <tbody>
          <tr v-for="(row, index) in data" :key="row.ts + row.value">
<!--            <td>{{ index + 1 }}</td>-->
            <td></td>
            <td style="color: #bfd5ff;">{{ row.ts}}</td>
            <td style="color: #bfd5ff">{{ row.value }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </dv-border-box-13>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {getAttributesClient, getCredentials} from "../untils/api/home";
  import moment from "moment"
  import videoDialog from "./popup/videoDialog.vue";

  export default {
    components: {
      videoDialog,
    },
    name: 'DeviceWarn',
    data() {
      return {
        data: [],
        scrollInterval: null,
        scrollDirection:1,
        musicTimer: '',
        deviceIdInfo: {},
        upList: [], //上限集合
        lowList: [], //下限集合
        thresholdList:[]
      }
    },

    mounted() {
      this.$nextTick(() => {
        this.startAutoScroll();
      });
    },
    beforeDestroy() {
      this.clearAutoScroll();
      if (this.musicTimer) {
        clearTimeout(this.musicTimer);
        this.musicTimer = null;
      }
    },

    methods: {
      startAutoScroll() {
        const el = this.$refs.scrollWrapper;
        if (!el) return;

        this.scrollInterval = setInterval(() => {
          el.scrollTop += this.scrollDirection;

          // 如果到底，切换为向上滚
          if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
            this.scrollDirection = -1;
          }

          // 如果到顶，切换为向下滚
          if (el.scrollTop <= 0) {
            this.scrollDirection = 1;
          }
        }, 30); // 滚动速度控制
      },
      pauseScroll() {
        this.clearAutoScroll();
      },
      resumeScroll() {
        this.startAutoScroll();
      },
      clearAutoScroll() {
        if (this.scrollInterval) {
          clearInterval(this.scrollInterval);
          this.scrollInterval = null;
        }
      },

      getDeviceWarn(deviceId, latestResponse) {
       //this.data = [];
       if(JSON.stringify(latestResponse) == "{}") {
         return;
       }

       if(this.deviceIdInfo.id !== deviceId.id) {
         document.getElementById('myAudio').pause();
         this.deviceIdInfo = deviceId;

         this.thresholdList = [];
         for(let obj in latestResponse) {
           if(obj != 'warn') {
             let thresholdJson = {
               name: obj,
               upperCH: this.$t(obj).split(',')[0] + this.$t('up'),
               upperEN: obj + '_up',
               lowerCH: this.$t(obj).split(',')[0] + this.$t('low'),
               lowerEN: obj + '_low',
               up: 0,
               low: 0
             };
             this.thresholdList.push(thresholdJson);
           }
         }
       }

        let newList = eval(localStorage.getItem("upLowList"));
        if(newList === null) {
          this.getClientAccess(latestResponse);
        } else {
          this.getNewUpLowList(newList, latestResponse);
        }
      },

      getNewUpLowList(newList, latestResponse) {
        // 工具函数：更新列表中指定 name 的值
        const updateListItem = (list, name, value) => {
          const index = list.findIndex(item => item.name === name);
          if (index !== -1) {
            list[index].value = value;
          } else {
            list.push({ name, value });
          }
        };

        for (const item of newList) {
          for (const key in item) {
            const match = key.match(/(.+?)_(up|low)$/);
            if (!match) continue;

            const name = match[1];            // e.g. "ambientHumidity"
            const state = match[2];           // "up" or "low"
            const value = Number(item[key]);  // 强制数值类型

            // ✅ 更新 thresholdList 中的 up/low 值
            const thresholdIndex = this.thresholdList.findIndex(el => el.name === name);
            if (thresholdIndex !== -1) {
              this.thresholdList[thresholdIndex][state] = value;
            }

            // ✅ 更新 upList / lowList 中的值
            const targetList = state === 'up' ? this.upList : this.lowList;
            updateListItem(targetList, name, value);
          }
        }

        // ✅ 重新计算报警数据
        this.$nextTick(() => {
          this.getFilterData(latestResponse);
        });
      },

      getClientAccess( latestResponse) {
        this.upList = [];
        this.lowList = [];
        getCredentials(this.deviceIdInfo.id).then(response => {
          //获取客户端遥测数据上下限值
          this.getUpLowList(response.credentialsId, latestResponse);
        }).catch(error => {
          console.log("error", error)
        })
      },

      getUpLowList(credentialsId,latestResponse) {
        getAttributesClient(credentialsId).then(response => {
          for (let obj in response.client) {
            if (obj.substring(obj.length - 3) === '_up') {
              let upJson = {};
              upJson.name = obj.substring(0, obj.length - 3);
              upJson.value = response.client[obj];
              this.upList.push(upJson);

              const existingIndex = this.thresholdList.findIndex(item =>item.name === upJson.name);
              if (existingIndex !== -1) {
                this.thresholdList[existingIndex].up = upJson.value
              }

            } else if (obj.substring(obj.length - 4) === '_low') {
              let lowJson = {};
              lowJson.name = obj.substring(0, obj.length - 4);
              lowJson.value = response.client[obj];
              this.lowList.push(lowJson);

              const existingIndex = this.thresholdList.findIndex(item =>item.name === lowJson.name);
              if (existingIndex !== -1) {
                this.thresholdList[existingIndex].low = lowJson.value
              }

            }
          }
          this.getFilterData(latestResponse);
        }).catch(error => {
          console.log("error", error)
        })
      },

      getFilterData(latestResponse) {
        let configList = [];
        let arrayUpLow = [];
        let snowRefer = localStorage.getItem('snowRefer'); //获取设置雪深值
        let levelRefer = localStorage.getItem('levelRefer');//获取设置的水位值
        let emptyHDRefer = localStorage.getItem('emptyHDRefer');//获取设置高程值
        let noiseRefer = localStorage.getItem('noiseRefer');//获取设置噪声值
        for (let obj in latestResponse) {
          if(obj == 'warn') {
            if(parseFloat(latestResponse[obj][0].value) != 0 ) {
              let des = this.$t('levelAlert') + parseFloat(latestResponse[obj][0].value) + this.$t('lightningAlert') ;
              configList.push({ts: this.dateFormat(latestResponse[obj][0].ts),  value: des });
              arrayUpLow.push({name: obj.toString(), state: 'up'});
              break;
            }
          }
          for (let up in this.upList) {
            let unit = this.$t(obj).split(',')[1] === undefined ? '' : this.$t(obj).split(',')[1];
            if((obj === this.upList[up].name) && (obj == "snowHeight" || obj == "snowheight" || obj == "sHt") && (Math.abs(parseFloat(snowRefer) +  parseFloat(latestResponse[obj][0].value)) > this.upList[up].value)) {
              let des = this.$t(obj).split(',')[0] + this.$t('is') + (Math.abs(parseFloat(snowRefer) +  parseFloat(latestResponse[obj][0].value))).toFixed().toString()+ unit + this.$t('upMessage');
              configList.push({ts: this.dateFormat(latestResponse[obj][0].ts), value: des});
              arrayUpLow.push({name: obj.toString(), state: 'up'});
              break;
            } else if((obj === this.upList[up].name) && (obj == "level" || obj == "Rwater" || obj == "waterlevel") && (Math.abs(parseFloat(levelRefer) +  parseFloat(latestResponse[obj][0].value)) > this.upList[up].value)){
              let des = this.$t(obj).split(',')[0] + this.$t('is') + (Math.abs(parseFloat(levelRefer) +  parseFloat(latestResponse[obj][0].value)))+ unit + this.$t('upMessage');
              configList.push({ts: this.dateFormat(latestResponse[obj][0].ts), value: des});
              arrayUpLow.push({name: obj.toString(), state: 'up'});
              break;
            } else if((obj === this.upList[up].name) && (obj == "emptyHD") && (Math.abs(parseFloat(emptyHDRefer) +  parseFloat(latestResponse[obj][0].value)) > this.upList[up].value)) {
              let des = this.$t(obj).split(',')[0] + this.$t('is') + (Math.abs(parseFloat(emptyHDRefer) +  parseFloat(latestResponse[obj][0].value))).toFixed(3).toString() + unit + this.$t('upMessage');
              configList.push({ts: this.dateFormat(latestResponse[obj][0].ts), value: des});
              arrayUpLow.push({name: obj.toString(), state: 'up'});
              break;
            } else if((obj === this.upList[up].name) && (obj == "noise" || obj == "noi" || obj == "noise1" || obj == "noise2") && (Math.abs(parseFloat(noiseRefer) +  parseFloat(latestResponse[obj][0].value)) > this.upList[up].value)) {
              let des = this.$t(obj).split(',')[0] + this.$t('is') + (Math.abs(parseFloat(noiseRefer) +  parseFloat(latestResponse[obj][0].value))).toFixed(1).toString()+ unit + this.$t('upMessage');
              configList.push({ts: this.dateFormat(latestResponse[obj][0].ts), value: des});
              arrayUpLow.push({name: obj.toString(), state: 'up'});
              break;
            } else if ((obj === this.upList[up].name) && (obj != "snowHeight") && (obj != "snowheight") && (obj != "sHt") && (obj != "level") && (obj != "Rwater") && (obj != "waterlevel")
              && (obj != "noise") && (obj != "noi") && (obj != "noise1'") && (obj != "noise2") && (obj != "emptyHD") && (latestResponse[obj][0].value > this.upList[up].value)) {
              let des = this.$t(obj).split(',')[0] + this.$t('is') + parseFloat(latestResponse[obj][0].value).toFixed(2) + unit + this.$t('upMessage');
              configList.push({ts: this.dateFormat(latestResponse[obj][0].ts),  value: des });
              arrayUpLow.push({name: obj.toString(), state: 'up'});
              break;
            }
          }

          for (let low in this.lowList) {
            let unit = this.$t(obj).split(',')[1] === undefined ? '' : this.$t(obj).split(',')[1];
            if((obj === this.lowList[low].name) && (obj == "snowHeight" || obj == "snowheight" || obj == "sHt") &&  (Math.abs(parseFloat(snowRefer) +  parseFloat(latestResponse[obj][0].value)) < this.lowList[low].value)){
              let des = this.$t(obj).split(',')[0] + this.$t('is') +  (Math.abs(parseFloat(snowRefer) +  parseFloat(latestResponse[obj][0].value))).toFixed().toString()+ unit +  this.$t('lowMessage');
              configList.push({ts: this.dateFormat(latestResponse[obj][0].ts),  value: des });
              arrayUpLow.push({name: obj.toString(), state: 'low'});
              break;
            } else if((obj === this.lowList[low].name) && (obj == "level" || obj == "Rwater" || obj == "waterlevel") &&  (Math.abs(parseFloat(levelRefer) +  parseFloat(latestResponse[obj][0].value)) < this.lowList[low].value)) {
              let des = this.$t(obj).split(',')[0] + this.$t('is') +  (Math.abs(parseFloat(levelRefer) +  parseFloat(latestResponse[obj][0].value)))+ unit +  this.$t('lowMessage');
              configList.push({ts: this.dateFormat(latestResponse[obj][0].ts),  value: des });
              arrayUpLow.push({name: obj.toString(), state: 'low'});
              break;
            } else if((obj === this.lowList[low].name) && (obj == "emptyHD") &&  (Math.abs(parseFloat(emptyHDRefer) +  parseFloat(latestResponse[obj][0].value)) < this.lowList[low].value)) {
              let des = this.$t(obj).split(',')[0] + this.$t('is') +  (Math.abs(parseFloat(emptyHDRefer) +  parseFloat(latestResponse[obj][0].value))).toFixed(3).toString() + unit +  this.$t('lowMessage');
              configList.push({ts: this.dateFormat(latestResponse[obj][0].ts),  value: des });
              arrayUpLow.push({name: obj.toString(), state: 'low'});
              break;
            } else if((obj === this.lowList[low].name) && (obj == "noise" || obj == "noi" || obj == "noise1" || obj == "noise2") &&  (Math.abs(parseFloat(noiseRefer) +  parseFloat(latestResponse[obj][0].value)) < this.lowList[low].value)) {
              let des = this.$t(obj).split(',')[0] + this.$t('is') +  (Math.abs(parseFloat(noiseRefer) +  parseFloat(latestResponse[obj][0].value))).toFixed(1).toString()+ unit +  this.$t('lowMessage');
              configList.push({ts: this.dateFormat(latestResponse[obj][0].ts),  value: des });
              arrayUpLow.push({name: obj.toString(), state: 'low'});
              break;
            } else if (obj === this.lowList[low].name && (obj != "snowHeight") && (obj != "snowheight")  && (obj != "sHt") && (obj != "level") && (obj != "Rwater") && (obj != "waterlevel")
              && (obj != "noise") && (obj != "noi") && (obj != "noise1'") && (obj != "noise2") && (obj != "emptyHD") && latestResponse[obj][0].value < this.lowList[low].value) {
              let des = this.$t(obj).split(',')[0] + this.$t('is') + parseFloat(latestResponse[obj][0].value).toFixed(2) + unit +  this.$t('lowMessage');
              configList.push({ts: this.dateFormat(latestResponse[obj][0].ts),  value: des });
              arrayUpLow.push({name: obj.toString(), state: 'low'});
              break;
            }
          }
        }

        //this.data = configList;
        configList.forEach(newItem => {
          const key = newItem.ts + newItem.value;
          const existingIndex = this.data.findIndex(item => item.ts + item.value === key);
          if (existingIndex !== -1) {
            this.data.splice(existingIndex, 1, newItem); // 更新已有
          } else {
            this.data.push(newItem); // 新增
          }
        });

        const configKeys = configList.map(item => item.ts + item.value);
        this.data = this.data.filter(item =>
          configKeys.includes(item.ts + item.value)
        );

        this.getThresholdParam(arrayUpLow);
        if (arrayUpLow.length > 0) {
          this.playMusic();
        }
      },

      playMusic() {
        clearTimeout(this.musicTimer); //清除延迟执行
        let audio = document.getElementById('myAudio');
        if (audio) {
          audio.play();
          this.musicTimer = setTimeout(() => {
            const audio = document.getElementById('myAudio'); // 再次获取，避免销毁
            if (audio) {
              audio.pause();
            }
          }, 1000 * 8);
        }
      },

      getThresholdParam(arrayUpLow) {
        if(arrayUpLow.length > 0) {
          this.$emit("callBackInfo", arrayUpLow);
        }
      },

      dateFormat(timestamp) {
        if (timestamp && timestamp != "") {
          let dateStr = moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
          return dateStr;
        }
        return "-";
      },

      popClick() {
        let labelName = this.thresholdList;
        let deviceInfo = this.deviceIdInfo;
        let originalList = JSON.parse(JSON.stringify(labelName));
        this.$popup({
          labelList: labelName,
          deviceInfo: deviceInfo,
          initList: originalList,
          click: () => {
          },
        })
      },

      videoClick() {
        let deviceInfo = this.deviceIdInfo;

        if (this._videoInstance) {
          this._videoInstance.$destroy();
          document.body.removeChild(this._videoInstance.$el);
          this._videoInstance = null;
        }

        // 这里用 Vue.extend 创建构造函数
        const VideoDialogConstructor = this.$options.components.videoDialog;

        // Vue.extend 需要在外部导入 Vue
        const Constructor = Vue.extend(VideoDialogConstructor);

        this._videoInstance = new Constructor({
          propsData: {
            deviceInfo: deviceInfo
          },
        }).$mount();

        document.body.appendChild(this._videoInstance.$el);
        this._videoInstance.show = true;
      }
    },

  }
</script>

<!--<style lang="less">-->
<!--  .dv-scroll-board .rows .ceil {-->
<!--    font-size: 18px ;-->
<!--  }-->
<!--</style>-->
<style scoped lang="less">
  @import "less/DeviceWarn.less";
</style>



// WEBPACK FOOTER //
// src/components/DeviceWarn.vue